// GENERATED FILE - DO NOT MODIFY

export enum GetUsersSortColumnDto {
    Name = "Name",
    ManagementRoles = "ManagementRoles",
    Team = "Team",
    JobTitle = "JobTitle",
    DefaultOffice = "DefaultOffice",
    IsFavorite = "IsFavorite",
}